import React, {useState} from 'react';
import Register from './Register';
import Login from './Login';
import ProfileChange from './ProfileChange';

function Logs({click}) {
    const [acc, setAcc] = useState(false);
    const switchAcc = () => {
        setAcc(!acc);
    }
    const [step, setStep] = useState(true);
    const next = () => {
        setStep(!step)
    }
    return (
        <div>
            {
            acc?
            step?
            <Register switchAcc={switchAcc} click={next}/>:<ProfileChange click={click}/> 
            :
            <Login switchAcc={switchAcc} click={click}/> 
            }
        </div>
    )
}

export default Logs
